import { Cradle, TotalInsights } from '@solo/app-core';
import { useEffect, useState } from 'react';
import { DashboardHelp, Flex, PlaysByCountry, PlaysByPlatform, RouterLink, Text } from '@/app/ui';
import { translate } from '@/app/i18n';
import MySongsInsights from '@/app/ui/organisms/Dashboard/MySongsInsights';
import { useCradle } from '@/app/contexts';
import Colors from '@/app/styles/Colors';
import { useBlocState } from '@/app/hooks';

const DashboardPage = () => {
  const { musicalWorksBloc, statisticsBloc, authBloc } = useCradle<Cradle>();
  const authState = useBlocState(authBloc);
  const [insightData, setInsightData] = useState<TotalInsights | undefined>();

  async function getInsightsData() {
    if (authState.kind !== 'AuthenticatedAuthState') return;
    const musicalReleases = await musicalWorksBloc.getMusicalReleases({
      filters: { userId: authState.user.id },
    });

    const totalEarnings = await statisticsBloc.getPendingEarnings();

    setInsightData({
      totalReleases: musicalReleases.data.length,
      totalNetRevenue: Number(totalEarnings.totalAmount.toFixed(2)),
      distributionRevenue: 0,
      publishingRevenue: 0,
    });
  }

  useEffect(() => {
    getInsightsData();
  }, []);

  return (
    <Flex.Container flexDirection="column" padding="3rem">
      <Flex.Container flexDirection="column" gap="3rem">
        <Flex.Container>
          <RouterLink $transparent to="/dashboard">
            <Text.Title2 style={{ marginRight: 5 }}>{translate('NAVBAR.DASHBOARD')}</Text.Title2>
          </RouterLink>
        </Flex.Container>
        <Flex.Container gap="3rem">
          <Flex.Container flexDirection="column" flex={1} gap="4rem">
            <Flex.Container style={{ width: '100%' }}>
              <Flex.Container flexDirection="column" gap="3rem">
                <Text.SubtitleBold>{translate('DASHBOARD.MY_RELEASES_INSIGHT')}</Text.SubtitleBold>
                <MySongsInsights insightData={insightData} />
              </Flex.Container>
              <Flex.Container flexDirection="column" gap="1rem" />
            </Flex.Container>
          </Flex.Container>
          <Flex.Container flexDirection="column" flex={1} gap="4rem" style={{ width: '100%' }}>
            <Flex.Container style={{ width: '100%' }}>
              <Flex.Container flexDirection="column" gap="3rem" flex={1}>
                <Text.SubtitleBold>{translate('BUTTON.ADD_RELEASE')}</Text.SubtitleBold>
                <Text.LabelMedium>{translate('WORKS.ADD_RELEASE_SUBTITLE')}</Text.LabelMedium>
                <Flex.Container gap="2rem">
                  <RouterLink to="/works/add-release" $size="md" $full>
                    <Text.SectionSubtitleBold style={{ color: Colors.white }}>
                      {translate('BUTTON.NEW_RELEASE')}
                    </Text.SectionSubtitleBold>
                  </RouterLink>
                </Flex.Container>
              </Flex.Container>
            </Flex.Container>
            {/* <Flex.Container style={{ width: '100%' }}>
              <Flex.Container flexDirection="column" gap="1rem" flex={1}>
                <Text.SubtitleBold>
                  {translate('DASHBOARD.TOP_3_EARNING_PLATFORMS')}
                </Text.SubtitleBold>
                <Top3EarningPlatforms />
              </Flex.Container>
            </Flex.Container> */}
          </Flex.Container>
        </Flex.Container>
      </Flex.Container>
      <Flex.Container style={{ width: '100%', marginTop: '3rem', marginBottom: '3rem' }}>
        <Flex.Container flexDirection="column" gap="1rem" flex={1}>
          <Text.SubtitleBold>{translate('USAGES.TOP_4_PLAYS_PLATFORMS')}</Text.SubtitleBold>
          <PlaysByPlatform top4 />
        </Flex.Container>
      </Flex.Container>
      <Flex.Container style={{ width: '100%' }}>
        <Flex.Container flexDirection="column" gap="1rem" flex={1}>
          <Text.SubtitleBold>{translate('DASHBOARD.PLAYS_COUNTRY')}</Text.SubtitleBold>
          <PlaysByCountry />
        </Flex.Container>
      </Flex.Container>
      <Flex.Container style={{ marginTop: '-10px' }}>
        <DashboardHelp />
      </Flex.Container>
    </Flex.Container>
  );
};

export default DashboardPage;
